import React from 'react';

import UsersComp from '../../components/users-comp';
import UserLayout from '../../shared/layouts/user-layout';
// style link end 

const UsersPage = () => {

    return (

        <UserLayout>
            <UsersComp />
        </UserLayout>
    )
}

export default UsersPage;


